export const STATUS_PENDING = 'PENDING'
export const STATUS_REVIEWED = 'REVIEWED'

export const STATUS_FILTER_OPTIONS = [
  { value: '', label: 'All' },
  { value: STATUS_PENDING, label: 'Not reviewed' },
  { value: STATUS_REVIEWED, label: 'Reviewed' },
]

export const DATE_PRESET_OPTIONS = [
  { value: '', label: 'All dates' },
  { value: 'today', label: 'Today' },
  { value: 'last_3_days', label: 'Last 3 days' },
  { value: 'last_7_days', label: 'Last 7 days' },
  { value: 'last_month', label: 'Last month' },
  { value: 'custom', label: 'Custom date' },
]

export const DEFAULT_CALENDAR_TIMEZONE = 'Asia/Dhaka'

export function statusLabel(status) {
  return status === STATUS_REVIEWED ? 'Reviewed' : 'Not reviewed'
}

export function formatMoney(value) {
  const n = Number(value)
  if (!Number.isFinite(n)) return '—'
  return `৳${n.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`
}

export function formatGapPct(gapPct) {
  if (gapPct == null || !Number.isFinite(Number(gapPct))) return '—'
  const n = Math.round(Number(gapPct) * 100) / 100
  return `${n}%`
}

export function formatSubmittedDate(value) {
  if (!value) return '—'
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return '—'
  return d.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
}

/** Format timestamps in the active browser timezone (same as Orders Date Modified). */
export function formatDateTime(value) {
  if (!value) return '—'
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return '—'
  return d.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  })
}

export function statusLogActorDisplay(entry) {
  if (!entry) return '—'
  return entry.performed_by_name || entry.performed_by_email || (entry.performed_by != null ? `Admin #${entry.performed_by}` : '—')
}

export function submitterDisplay(submittedBy) {
  if (!submittedBy) return '—'
  return submittedBy.name || submittedBy.phone || '—'
}

export function isImageProof(proof) {
  if (!proof) return false
  const mime = String(proof.mime_type || '').toLowerCase()
  if (mime.startsWith('image/')) return true
  const name = String(proof.name || proof.url || '')
  return /\.(jpe?g|png|gif|webp)$/i.test(name)
}

export function isPdfProof(proof) {
  if (!proof) return false
  const mime = String(proof.mime_type || '').toLowerCase()
  if (mime === 'application/pdf') return true
  const name = String(proof.name || proof.url || '')
  return /\.pdf$/i.test(name)
}

/**
 * Build query params for list/summary/export.
 * Omits page/limit when includePagination is false.
 */
export function buildPriceConcernQuery(filters, { includePagination = true } = {}) {
  const params = {
    calendarTimezone: DEFAULT_CALENDAR_TIMEZONE,
  }

  if (includePagination) {
    params.page = (filters.page ?? 0) + 1
    params.limit = filters.rowsPerPage ?? 20
  }

  const search = String(filters.search || '').trim()
  if (search) params.search = search

  if (filters.status) params.status = filters.status

  const preset = filters.datePreset || ''
  if (preset && preset !== 'custom') {
    params.datePreset = preset
  } else if (preset === 'custom' && (filters.dateFrom || filters.dateTo)) {
    params.datePreset = 'custom'
    if (filters.dateFrom) params.dateFrom = filters.dateFrom
    if (filters.dateTo) params.dateTo = filters.dateTo
  }

  return params
}

export function downloadBlobResponse(response, fallbackName = 'price-concerns.csv') {
  const disposition = response?.headers?.['content-disposition'] || ''
  const match = /filename="?([^"]+)"?/i.exec(disposition)
  const filename = match?.[1] || fallbackName
  const blob = new Blob([response.data], {
    type: response.headers?.['content-type'] || 'text/csv;charset=utf-8',
  })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}
